import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiCommentsConstants } from "src/app/shared/constants/api-constants/api-comments.constants";
import { ApiViewDocumentsConstants } from "../../unsecure-view-documents/service/unsecure-view-document.service.constants";
let UnsecureCommentService = class UnsecureCommentService {
    http;
    constructor(http) {
        this.http = http;
    }
    getUnsecureLookupsObservable(params) {
        return this.http.get(`${ApiCommentsConstants.URL}/${ApiCommentsConstants.FUNCTION_GET_PUBLIC_BU_LOOKUPS}`, { params }).pipe(map(lookups => {
            return lookups;
        }));
    }
    getRequestCommentObservable(params) {
        const url = `${ApiCommentsConstants.URL}/${ApiCommentsConstants.FUNCTION_GET_PUBLIC_REQUEST_COMMENT}`;
        return this.http.get(url, { params }).pipe(map(requestComment => {
            return requestComment;
        }));
    }
    saveUnsecureComment(params) {
        return this.http.post(`${ApiCommentsConstants.URL}/${ApiCommentsConstants.FUNCTION_SAVE_PUBLIC_COMMENT}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    uploadAttachment(document, key) {
        return this.http.post(`${ApiCommentsConstants.URL}/${key}/${ApiCommentsConstants.FUNCTION_UPLOAD_ATTACHMENT}`, document);
    }
    getAttachmentContentObservable(attachmentId) {
        return this.http.get(`${ApiViewDocumentsConstants.URL}/${attachmentId}/${ApiViewDocumentsConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`, { responseType: "blob" });
    }
    getResponsiblePersonsObservable(params) {
        return this.http.post(`${ApiCommentsConstants.URL}/GetPublicResponsiblePersons`, params).pipe(map(response => {
            return response.value;
        }));
    }
    getStepMetaObservable(params, key) {
        return this.http.get(`${ApiCommentsConstants.URL}/${key}/GetPublicStepMetaData`, { params });
    }
    getModuleRoleAndUsersObservable(params, key) {
        return this.http.get(`${ApiCommentsConstants.URL}/${key}/GetPublicModuleRoleAndUsers`, { params }).pipe(map(result => {
            return result.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
UnsecureCommentService = __decorate([
    Injectable({
        providedIn: "root"
    })
], UnsecureCommentService);
export { UnsecureCommentService };
